import VenueRecommendations, { RecommendedVenuesProps } from './VenueRecommendations';

export { RecommendedVenuesProps };
export default VenueRecommendations;
